import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getListPasienPoliklinik(tgl, unitId, dokterId, status = "0") {
  const response = await http
    .getDataParam(`/poli/${unitId}/daftar-pasien`, {
      params: {
        tgl: tgl,
        status: status,
        cdoc_id: dokterId
      }
    })
    .catch(err => {
      console.log("catch err", err.response);
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getListPasienUnitRalanByTanggal(unitId, tgl) {
  const response = await http
    .getData(`/unit/${unitId}/tanggal/${tgl}/daftar-pasien`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getListPasienByTanggalDokter(tgl, cdocId, unitId = undefined) {
  const response = await http
    .getDataParam(`/daftar-pasien/tanggal/${tgl}/dokter/${cdocId}`, {
      unit: unitId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getListPasienRanapActiveByTanggal(
  tgl,
  cdocId,
  unitId = undefined
) {
  const response = await http
    .getDataParam(`/daftar-pasien/tanggal/${tgl}`, {
      unit: unitId,
      dokter: cdocId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getListPasienPenunjang(tgl, unitId, unitAsal = "") {
  const response = await http
    .getDataParam(`/unit-penunjang/${unitId}/daftar-pasien`, {
      params: {
        tgl: tgl,
        unit_asal: unitAsal || ""
      }
    })
    .catch(err => {
      console.log("catch err", err.response);
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getListPasienResumeIncomplete(unitId) {
  const response = await http
    .getDataParam(`/unit-ranap/${unitId}/daftar-pasien-incompleted`, {
      params: {}
    })
    .catch(err => {
      console.log("catch err", err.response);
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getListPasienPoliklinik,
  getListPasienUnitRalanByTanggal,
  getListPasienByTanggalDokter,
  getListPasienRanapActiveByTanggal,
  getListPasienPenunjang,
  getListPasienResumeIncomplete
};
